
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Alpträumen kann eine psychische Störung zugrunde liegen. Kehren diese Träume immer wieder zurück, kann es helfen, diese einer vertrauten Person zu erzählen. Stehen sie aber in Zusammenhang mit einem schwerwiegenden Erlebnis, kann es sich um eine psychische Belastungsstörung handeln. Der Alptraum führt dann quasi ein Eigenleben und hat sich im Gehirn festgesetzt. In den meisten Fällen wird über die Träume Erlebtes verarbeitet. Gelingt das nicht, können Therapeuten helfen, die vergangenen belastenden Ereignisse in der Realität «umzuschreiben», damit es das Hirn nachts nicht mehr tun muss.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;